(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["conpanna-brand-gallery"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('conpanna-brand-carousel')){
 customElements.define('conpanna-brand-carousel',class extends HTMLElement{
  connectedCallback(){
   if(this.ready)return;
   this.ready=true;
   const rail=this.querySelector('.cbg__rail'),buttons=[...this.querySelectorAll('[data-direction]')];
   const update=()=>{buttons[0].disabled=rail.scrollLeft<2;buttons[1].disabled=rail.scrollLeft+rail.clientWidth>=rail.scrollWidth-2;};
   buttons.forEach(button=>button.addEventListener('click',()=>{const card=rail.querySelector('.cbg__card');rail.scrollBy({left:Number(button.dataset.direction)*(card.getBoundingClientRect().width+parseFloat(getComputedStyle(rail).gap)),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});}));
   rail.addEventListener('scroll',update,{passive:true});
   this.resizeObserver=new ResizeObserver(update);this.resizeObserver.observe(rail);update();
  }
  disconnectedCallback(){this.resizeObserver?.disconnect();this.ready=false;}
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["conpanna-product-edit"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('conpanna-product-edit')){
customElements.define('conpanna-product-edit',class extends HTMLElement{
 connectedCallback(){
  if(this.dataset.ready)return;
  const tabs=[...this.querySelectorAll('[data-tab]')],panels=[...this.querySelectorAll('[data-panel]')];
  if(!tabs.length)return;
  this.querySelector('[data-tabs]').setAttribute('role','tablist');
  const select=(index,focus=false)=>{tabs.forEach((tab,i)=>{tab.setAttribute('aria-selected',String(i===index));tab.tabIndex=i===index?0:-1;panels[i].hidden=i!==index});if(focus)tabs[index].focus()};
  tabs.forEach((tab,i)=>{tab.id='edit-tab-'+panels[i].id;tab.setAttribute('role','tab');tab.setAttribute('aria-controls',panels[i].id);panels[i].setAttribute('role','tabpanel');panels[i].setAttribute('aria-labelledby',tab.id);tab.addEventListener('click',e=>{e.preventDefault();select(i)});tab.addEventListener('keydown',e=>{let next=i;if(e.key==='ArrowRight')next=(i+1)%tabs.length;else if(e.key==='ArrowLeft')next=(i-1+tabs.length)%tabs.length;else if(e.key==='Home')next=0;else if(e.key==='End')next=tabs.length-1;else return;e.preventDefault();select(next,true)})});
  select(0);this.dataset.ready='true';
  this.addEventListener('shopify:block:select',e=>{const i=panels.findIndex(p=>p===e.target||p.contains(e.target));if(i>=0)select(i)});
 }
});}

  } catch(e) { console.error(e); }
})();
})();
